/*!

 =========================================================
 * Vue Now UI Kit - v1.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/now-ui-kit
 * Copyright 2019 Creative Tim (http://www.creative-tim.com)

 * Designed by www.invisionapp.com Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import Vue from 'vue';
import App from './App.vue';
// You can change this import to `import router from './starterRouter'` to quickly start development from a blank layout.
import router from './router';
import NowUiKit from './plugins/now-ui-kit';
import VueCookie from 'vue-cookie';
import { ListGroupPlugin, CardPlugin, ButtonPlugin, SpinnerPlugin, ModalPlugin, FormPlugin, FormGroupPlugin, FormInputPlugin, FormTextareaPlugin, ToastPlugin, AlertPlugin, TooltipPlugin, VBPopoverPlugin , MediaPlugin, DropdownPlugin, CarouselPlugin, SidebarPlugin  } from 'bootstrap-vue'
import VueSocialSharing  from 'vue-social-sharing';
import Vuetify from 'vuetify';
import localeMixin from './i18n/localeMixin';
import './assets/styles/tailwind.generated.css';
import { grantAnalyticsConsent, initAnalytics, trackPageView } from './utils/analytics';

Vue.config.productionTip = false;
Vue.mixin(localeMixin);
Vue.use(VueCookie);
Vue.use(NowUiKit);
Vue.use(ListGroupPlugin);
Vue.use(CardPlugin);
Vue.use(ButtonPlugin);
Vue.use(SpinnerPlugin);
Vue.use(ModalPlugin);
Vue.use(FormPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormInputPlugin);
Vue.use(FormTextareaPlugin);
Vue.use(ToastPlugin);
Vue.use(AlertPlugin);
Vue.use(TooltipPlugin);
Vue.use(VueSocialSharing);
Vue.use(VBPopoverPlugin);
Vue.use(MediaPlugin);
Vue.use(DropdownPlugin);
Vue.use(CarouselPlugin);
Vue.use(SidebarPlugin);
Vue.use(Vuetify);

initAnalytics();
if (VueCookie.get('acceptCookies') === 'true') {
  grantAnalyticsConsent();
}

router.afterEach((to) => {
  trackPageView(to.fullPath);
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
